import Config from './messages';
import {RESOURCES as reportsResources} from './fuseReportsResourceMap';
import {RESOURCES as salesSummaryReportsResources} from './fuseSalesSummaryReportsResourceMap';
import {RESOURCES as combinedReportsResources} from './fuseCombinedSalesReportsResourceMap';
import {RESOURCES as systemResources} from './fuseSystemsResourceMap';
import {RESOURCES as jobResources} from './fuseJobsResourceMap';
import {RESOURCES as locationResources} from './fuseLocationsResourceMap';
import {RESOURCES as searchResources} from './fuseSearchResourceMap';
import {
    interceptLoadData,
    createPayload,
    assignPayload
} from './restClientPreProcess';
import {
    generateId,
    postProcessData,
    setUniqueKeys
} from './restClientPostProcess';

/**
 * Resource Maps
 */
const fuseResourceMap = {

    "CreditCardTransactions": reportsResources.CreditCardTransactions,
    "DefaultPricesByProductType": reportsResources.DefaultPricesByProductType,
    "DetailedSales": reportsResources.DetailedSales,
    "FinalAuditItems": reportsResources.FinalAuditItems,
    "FinalAuditsByZeroDay": reportsResources.FinalAuditsByZeroDay,
    "InventoryByZeroDay": reportsResources.InventoryByZeroDay,
    "ItemReturnsByDate": reportsResources.ItemReturnsByDate,
    "ItemSalesByDate": reportsResources.ItemSalesByDate,
    "RecentTransactions": reportsResources.RecentTransactions,
    "SalesComparisonByDate": reportsResources.SalesComparisonByDate,
    "SalesComparisonLocationByDate": reportsResources.SalesComparisonLocationByDate,
    "SalesTaxAudit": reportsResources.SalesTaxAudit,
    "SaleSummaryByZeroDay": reportsResources.SaleSummaryByZeroDay,
    "ScheduledReports": reportsResources.ScheduledReports,
    "ReportJobs": jobResources.ReportJobs,
    "TransferItemTotals": reportsResources.TransferItemTotals,
    "TransactionLogByDate": reportsResources.TransactionLogByDate,
    "TransactionLogLocationByDate": reportsResources.TransactionLogLocationByDate,
    "TransactionsByDay": reportsResources.TransactionsByDay,
    "VIPCustomersProductsAggregatedByLocation": reportsResources.VIPCustomersProductsAggregatedByLocation,
    "VIPUsage": reportsResources.VIPUsage,
    "ZeroDays": reportsResources.ZeroDays,

    "SalesSummaryAll": salesSummaryReportsResources.SalesSummaryAll,
    "SalesSummaryByLocation": salesSummaryReportsResources.SalesSummaryByLocation,
    "SalesSummarybyDba": salesSummaryReportsResources.SalesSummaryByDba,
    "SalesSummarybyDistrict": salesSummaryReportsResources.SalesSummaryByDistrict,
    "SalesSummaryByState": salesSummaryReportsResources.SalesSummaryByState,
    "SalesSummaryByStateCity": salesSummaryReportsResources.SalesSummaryByStateCity,
    "SalesSummaryByStateDba": salesSummaryReportsResources.SalesSummaryByStateDba,
    "SalesSummaryBihourlyAll": salesSummaryReportsResources.SalesSummaryBihourlyAll,
    "SalesSummaryHourlyByLocation": salesSummaryReportsResources.SalesSummaryHourlyByLocation,
    "SalesSummaryHourlyByDba": salesSummaryReportsResources.SalesSummaryHourlyByDba,
    "SalesSummaryHourlyByDistrict": salesSummaryReportsResources.SalesSummaryHourlyByDistrict,
    "SalesSummaryHourlyByState": salesSummaryReportsResources.SalesSummaryHourlyByState,
    "SalesSummaryHourlyByStateCity": salesSummaryReportsResources.SalesSummaryHourlyByStateCity,
    "SalesSummaryHourlyByStateDba": salesSummaryReportsResources.SalesSummaryHourlyByStateDba,

    "CombinedSalesAll": combinedReportsResources.CombinedSalesAll,
    "CombinedSalesByDba": combinedReportsResources.CombinedSalesByDba,
    "CombinedSalesByLocation": combinedReportsResources.CombinedSalesByLocation,
    "CombinedSalesByDistrict": combinedReportsResources.CombinedSalesByDistrict,
    "CombinedSalesByState": combinedReportsResources.CombinedSalesByState,
    "CombinedSalesByStateCity": combinedReportsResources.CombinedSalesByStateCity,
    "CombinedSalesByStateDBA": combinedReportsResources.CombinedSalesByStateDBA,

    "VIPSignups": searchResources.VIPSignups,

    "Systems": systemResources.Systems,
    "Locations": locationResources.Locations,
};

/**
 * Checks for the presence of a valid stored server
 */
const checkServer = () => {
    const server = localStorage.getItem('server');
    if (!server) {
        //console.log('NO SERVER');
    }
};

/**
 * Parse data for Get or Post returns
 */
const parseAck = (type, ack, parseParams, params) => {

    let data = ack.payload;
    if (!data) {
        return;
    }

    // List
    if (type === 'list') {
        let keys = [];

        for (let i = 0; i < data.length; i++) {
            if (parseParams) {
                if (parseParams.hasNameKeys) {
                    // Resources with unique names
                    keys.push(data[i].name);
                    data[i].id = data[i].name;
                } else if (parseParams.isArray) {
                    // Resources that return a simple string array
                    const name = data[i];
                    keys.push(name);
                    data[i] = {id: name, name: name};
                } else if (parseParams.needsId) {
                    // Resources that need a unique ID
                    data[i].id = generateId();
                    keys.push(data[i].id);
                } else if (parseParams.idKey) {
                    // Resources with a unique key that is not "id"
                    let idValue = null;
                    if (parseParams.parentKey) {
                        idValue = data[i][parseParams.parentKey][parseParams.idKey];
                    } else {
                        idValue = data[i][parseParams.idKey];
                    }
                    keys.push(idValue);
                    data[i].id = idValue;
                } else {
                    keys.push(data[i].id);
                }
            } else {
                keys.push(data[i].id);
            }
        }

        let total = ack.payload.length;

        if (ack.payload_meta && ack.payload_meta.total) {
            total = ack.payload_meta.total;
        }
        if (!total) {
            total = 0;
        }

        return {
            "data": data,
            "ids": keys,
            "total": total
        }
    }

    // Get One: Return either first element in data array or data
    if (type === 'item') {

        if (parseParams && parseParams.needsId) {
            // If the Resource needs a generated ID:
            const id = generateId();
            if (data[0]) {
                data[0].id = id;
            } else {
                data.id = id;
            }
        }
        if (parseParams && parseParams.idKey) {
            // If the Resource has a unique key to use as the ID:
            if (data[0]) {
                data[0].id = data[0][parseParams.idKey];
            } else {
                data.id = data[parseParams.idKey];
            }
        }
        return data[0] ? {"data": data[0]} : {"data": data};
    }

    // Create and Edit: Return data
    if (type === 'upsert') {
        return data;
    }

    // Delete: Return data
    if (type === 'delete') {
        return data;
    }

    return {"data": {}}
};

/**
 * Load data from a CloudSent POS Resource Map
 */
const loadFuseData = (type, resource, params, resolve, reject) => {

    let data = null;
    const emptyData = {data: [{id: '', name: ''}], ids: [''], total: 0};

    // If request lacks data and should not automatically get data, resolve as empty
    if (interceptLoadData(type, resource, params)) {
        resolve(emptyData);
        return;
    }

    let cfg = fuseResourceMap[resource][type](params);
    let rdata;
    let xhr = new XMLHttpRequest();

    xhr.addEventListener("readystatechange", function () {
        if (this.readyState === 4) {
            let ack;
            try {
                ack = JSON.parse(this.responseText);
                if (ack.success !== true) {
                    if (ack.error_message && typeof ack.error_message === 'string') {
                        reject('Error: ' + ack.error_message);
                    } else if (ack.payload && typeof ack.payload === 'string') {
                        reject('Error: ' + ack.payload);
                    } else {
                        reject(Config.fuse.notification.server_error);
                    }
                    return;
                }
            } catch (e) {
                reject(Config.fuse.notification.no_data);
                return;
            }

            // Mark resources with no ids or variable unique identifiers
            const parseParams = setUniqueKeys(resource, type);

            rdata = parseAck(cfg.type, ack, parseParams, params);
            //console.log('loadFuseData parseAcked rdata: ', rdata);

            // If no payload is available, display an error
            if (!rdata || (rdata.data && typeof rdata.data !== 'object')) {
                reject('No ' + cfg.title + ' available.');
                return;
            }

            // Post-process data for specific resources
            rdata = postProcessData(resource, type, params, rdata);

            resolve(rdata);
        }
    });

    let method = cfg.method;
    let uri = cfg.uri;

    xhr.open(method, uri);
    xhr.setRequestHeader("Cache-Control", "no-cache");

    // Send a token
    const token = localStorage.getItem('token');
    xhr.setRequestHeader("Authorization", "Bearer " + token);

    xhr.send(data);
};

/**
 * Post data through a CloudSent POS Resource Map
 */
const upsertFuseData = (type, resource, params, resolve, reject) => {
    // Retrieve the resource uri
    let cfg = fuseResourceMap[resource][type](params);
    let rdata;
    let xhr = new XMLHttpRequest();
    // Create a payload object
    let payload = createPayload(resource);

    xhr.addEventListener("readystatechange", function () {
        if (this.readyState === 4) {
            let ack;
            try {
                ack = JSON.parse(this.responseText);
                if (ack.success !== true) {
                    if (ack.payload && typeof ack.payload === 'string') {
                        reject('Error: ' + ack.payload);
                    } else {
                        reject(Config.fuse.notification.server_error);
                    }
                    return;
                }
            } catch (e) {
                reject(Config.fuse.notification.no_data);
                return;
            }

            rdata = parseAck(cfg.type, ack, null, params);
            //console.log('upsertFuseData parseAcked rdata: ', rdata);

            // If no payload is returned, display an error notification
            if (!rdata) {
                console.log('No data');
                reject(Config.fuse.notification.no_data);
            }

            // If no data key is available:
            if (!params.data && params.previousData) {
                params.data = params.previousData;
            }

            resolve({'data': params.data});
        }
    });

    xhr.open("POST", cfg.uri);

    // Send a token
    const token = localStorage.getItem('token');
    xhr.setRequestHeader("Authorization", "Bearer " + token);

    // Assemble the payload model or other object(s)
    payload = assignPayload(type, resource, cfg.data);

    xhr.send(JSON.stringify(payload));
};

export default (type, config = {}, options = {}) => {

    // Check for a valid server before proceeding
    checkServer();

    /**
     * @param {string} type Request type, e.g GET_LIST
     * @param {string} resource Resource name, e.g. "TransactionsByDay"
     * @param {Object} params Request parameters. Depends on the request type
     * @returns {Promise} the Promise for a REST response
     */
    return (type, resource, params) => {
        if (type === 'GET_LIST' || type === 'GET_ONE' || type === 'GET_MANY' || type === 'GET_MANY_REFERENCE') {
            // console.log('restClient type: ' + type + ', resource: ' + resource);
            // console.log('restClient params: ', params);
            return new Promise((resolve, reject) => {
                loadFuseData(type, resource, params, resolve, reject);
                return true;
            })
        }
        if (type === 'CREATE' || type === 'UPDATE' || type === 'DELETE') {
            // console.log('restClient params: ', params);
            return new Promise((resolve, reject) => {
                upsertFuseData(type, resource, params, resolve, reject);
                return true;
            })
        }
    }
}



// WEBPACK FOOTER //
// ./src/Fuse/restClient.js